const localeEn = {
  // Degree card
  UDE_GO_TO_DEGREE_LIST: 'View all my MicroDegrees',
  UDE_DEGREE_START_DATE: 'Start date: {{date}}',
  UDE_DEGREE_FINAL_PROJECT_START: 'Final project start: {{date}}',
  UDE_DEGREE_FINAL_PROJECT_DEADLINE: 'Final project deadline: {{date}}',
  UDE_DEGREE_COMPLETED_SHORT: 'Degree completed',
  UDE_BOOTCAMP_COMPLETED_SHORT: 'Bootcamp completed',
  UDE_DEGREE_COMPLETED:
    'Congratulations! You have successfully completed your MicroDegree.',
  UDE_BOOTCAMP_COMPLETED:
    'Congratulations! You have successfully completed your Bootcamp.',
  UDE_DOWNLOAD_DIPLOMA: 'Download diploma',
  UDE_DOWNLOAD_CERTIFICATE: 'Download certificate',
  UDE_DOWNLOAD_PARTICIPATION_CERTIFICATE: 'Download participation certificate',
  UDE_COMPLETED_COURSES: 'Completed courses of the MicroDegree',
  UDE_TOTAL_APPROVED_PROJECTS: 'Total approved projects',
  UDE_TOTAL_ATTENDENCE: 'Total attendance',
  UDE_CHAT_WITH_OTHER_STUDENTS: 'Interact with other Bootcamp students',
  UDE_REQUIRED_APPROVED_PROJECTS: 'Required approved projects',
  UDE_OPTIONAL_APPROVED_PROJECTS: 'Optional approved projects',
  UDE_DEGREE_ATTACHMENTS_TITLE:
    'Resolve your doubts with our MicroDegree guides',
  UDE_BOOTCAMP_ATTACHMENTS_TITLE:
    'Resolve your doubts with our Bootcamp guides',
  UDE_DEGREE_ATTACHMENTS_LINK: 'Download guides',
  UDE_DEGREE_ATTACHMENTS_DIALOG_TITLE: 'Download support guides here',
  UDE_DEGREE_UNAVAILABLE_LINK: 'Coming soon',
  UDE_DEGREE_ROADMAP_TITLE: 'MicroDegree roadmap',
  UDE_BOOTCAMP_ROADMAP_TITLE: 'Bootcamp roadmap',
  UDE_PENDING_PROJECTS: '{{count}} pending project',
  UDE_PENDING_PROJECTS_plural: '{{count}} pending projects',
  UDE_MODULE_WORKBOOK_BOOTCAMP: 'Workbook - {{module}}',
  UDE_DOWNLOAD_WORKBOOK: 'Download workbook',
  UDE_REQUIRED_PROJECTS_ALERT:
    'To start your final project, you must have completed the {{total}} partial projects of your MicroDegree.',
  // Course item
  UDE_COURSE_LABEL: 'Course {{order}}',
  UDE_COURSE_MODULES: '{{modules}} modules',
  UDE_DOWNLOAD_COURSE_ATTACHMENTS: 'Download course attachments',
  UDE_ENABLED_AT: 'Available {{date}}',
  // Project item
  UDE_REQUIRED_PROJECT_LABEL: 'Partial Project #{{order}}',
  UDE_REQUIRED_PROJECT_DESC:
    'Completing this project is **mandatory** for the delivery of your final project.',
  UDE_OPTIONAL_PROJECT_LABEL: 'Optional Project #{{order}}',
  UDE_OPTIONAL_PROJECT_DESC:
    'Completing this project is **optional** for the delivery of your final project.',
  UDE_FINAL_PROJECT_LABEL: 'Final Project',
  UDE_FINAL_PROJECT_DESC:
    'To start your final project, **you must have approved all the partial projects of your MicroDegree**.',
  UDE_EMPTY_PROJECT_TITLE: 'Untitled Project',
  UDE_PROJECT_START: 'Start {{date}}',
  UDE_PROJECT_DEADLINE: 'Deadline {{date}}',
  UDE_FINAL_PROJECT_EXPIRED: 'Project submission is no longer available',
  // Event item
  UDE_SCHEDULE_EVENT: 'Add to calendar',
  UDE_SCHEDULE_EVENT_AGAIN: 'Schedule again',
  UDE_GO_TO_COMPLEMENTARY_SESSION: 'Go to session',
  UDE_GO_TO_COUNSELLING: 'Go to counseling',
  UDE_GO_TO_KICKOFF: 'Go to onboarding',
  UDE_GO_TO_EXTERNAL_SESSION: 'Go to zoom',
  UDE_GO_TO_CLASS_MATERIAL: 'View class material',
  UDE_WATCH_COMPLEMENTARY_SESSION: 'Watch recorded session',
  UDE_WATCH_COUNSELLING: 'Watch recorded counseling',
  UDE_WATCH_KICKOFF: 'Watch recorded onboarding',
  UDE_OPEN_DISCORD: 'Open discord',
  // Error view
  UDE_DEGREE_ERROR: 'An error occurred while retrieving your MicroDegree',
};

export default localeEn;
